import { ConfirmDestructiveDialog } from '@/shared/components/ConfirmDestructiveDialog';

import { isAiProviderError } from '../errors';

/**
 * Confirms removing one AI Provider.
 *
 * Mirrors `llm-profiles/components/LlmProfileDeleteDialog.tsx`: a blocked
 * delete (default provider, or referenced by an LLM Profile — FR-009/FR-009b)
 * is a recoverable refusal the admin needs to read, so this dialog stays open
 * and renders the mapped message rather than just toasting and closing.
 */
export function AiProviderDeleteDialog({
  name,
  open,
  isPending,
  error,
  onConfirm,
  onCancel,
}: {
  name: string;
  open: boolean;
  isPending: boolean;
  error: unknown;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const serverError = isAiProviderError(error) ? error : undefined;
  const message =
    serverError?.message ??
    (error ? 'The request failed. Please try again.' : null);

  return (
    <ConfirmDestructiveDialog
      open={open}
      title={<>Delete &ldquo;{name}&rdquo;?</>}
      confirmLabel="Delete provider"
      isPending={isPending}
      error={message}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      This removes the &ldquo;{name}&rdquo; AI Provider. Any LLM Profile still
      referencing it must be reassigned first.
    </ConfirmDestructiveDialog>
  );
}
